export default __webpack_public_path__ + "static/media/VideoThumbnail5.3c185522.svg";